<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-02 19:29:11
 * @LastEditors: yd
 * @LastEditTime: 2020-08-11 09:32:35
--> 
<template>
  <div>
    <staffOfficial></staffOfficial>
  </div>
</template> 
 
<script>
import staffOfficial from './staffOfficial'
export default {
  components: {
    staffOfficial
  },
  data () {
    return {
    }
  },
  mounted () {
  },
  methods: {

  },
  watch: {
  }
}
</script>